import React from "react";
import {
  NumberField,
  FunctionField,
  TabbedShowLayout,
  Tab,
  TextField,
  Show,
  ReferenceManyField,
  Datagrid,
  DateField,
  ShowButton,
  Button,
  CardActions,
  Link,
  EditButton,
} from "react-admin";
import { getPermissionRole } from "../util";

import { isEmpty, propEq, prop, filter, head, sum, map } from "ramda";

import { parse } from "query-string";
import moment from "moment";
import moment_tz from 'moment-timezone';
import CreateChargeButton from "../components/createCharge";
import { DATEFORMAT } from "../date-config";
import { buildRentalPromoSnapshot } from "../util/rentalPromo";
import { RentalPromoBadges } from "../components/RentalPromoBadges";

const cardActionStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right",
};
moment_tz.tz.setDefault("Europe/Madrid");
const RentalClientsShowTitle = (object) => (
  <span>
    {" Rental detail for Client "} &quot;
    {`${object.record.booking.r_first_name} ${object.record.booking.r_last_name}`}
    &quot;
  </span>
);

const RentalShowActions = ({
  basePath,
  data,
  resource,
  redirect,
  permissions, props
}) => {
  let pendingCharges = [];

  if (data && !isEmpty(data.payments)) {
    pendingCharges = filter(
      propEq("status", false),
      prop("charges", head(data.payments))
    );
  }
  const from = props.location;

  return (
    <CardActions style={cardActionStyle}>
      <Button
        component={Link}
        to={{
          pathname: `/${redirect}`,
        }}
        label="Go Back"
      />
      {data &&
        //moment(data.date_2).diff(Date.now(), "days") > 0 &&
        //isEmpty(pendingCharges) &&
        ([1, 2, 3, 6, 9].includes(getPermissionRole())) && (
          <EditButton
            to={{
              pathname: `/process_rental_edit/${data.id}`,
              search: `${from.search}`,
            }}
            label="Edit"
          />
        )}
    </CardActions>
  );
};

export const RentalClientsShow = ({ permissions, ...props }) => {
  const from = props.location.search || null;
  const redirect = from ? from : "rentals";

  return (
    <Show
      {...props}
      title={<RentalClientsShowTitle />}
      actions={
        <RentalShowActions permissions={permissions} props={props} redirect={redirect}/>
      }
    >
      <TabbedShowLayout>
        <Tab label="Rental Details">
          <FunctionField
            addLabel={false}
            render={(rental) => {
              if (isEmpty(rental.payments)) {
                return (
                  <span
                    style={{
                      color: "red",
                      fontSize: "17px",
                    }}
                  >
                    <b>This rental was not processed yet</b>
                  </span>
                );
              }
            }}
          />

          <FunctionField
            addLabel={false}
            render={(rental) => {
              if (rental.rental_status === 3) {
                const charges = prop("charges", head(rental.payments));
                
                let totalRefunded = 0;
                if(charges){
                  totalRefunded =
                    sum(
                      map(
                        prop("refunded_value"),
                        filter(
                          propEq("status", true),
                          filter(propEq("to_refund", true), charges)
                        )
                      )
                    );
                }
                

                return (
                  <div>
                    <h3>Canceled Rental </h3>
                    <p>Refunded value: {totalRefunded} € </p>
                  </div>
                );
              }
              return "";
            }}
          />

          <FunctionField
            label="Rental Info"
            render={(rental) => {
              return `From ${moment.utc(rental.date_1).format(DATEFORMAT)} (${rental.time_1
                }) to ${moment.utc(rental.date_2).format(DATEFORMAT)} (${rental.time_2
                })`;
            }}
          />

          <FunctionField
            label="Pick-up"
            render={(rental) => {
              const location = rental.location_1.location_name;
              const date = moment(rental.date_1);
              const time = rental.time_1 === "10:00:00" ? "morning" : "evening";
              return `${location} on ${date.format(
                "dddd"
              )} ${time}, ${date.format(DATEFORMAT)}`;
            }}
          />
          <FunctionField
            label="Drop-off"
            render={(rental) => {
              const location = rental.location_2.location_name;
              const date = moment(rental.date_2);
              const time = rental.time_2 === "10:00:00" ? "morning" : "evening";
              return `${location} on ${date.format(
                "dddd"
              )} ${time}, ${date.format(DATEFORMAT)}`;
            }}
          />

          <FunctionField
            label="Rental Duration"
            render={(rental) => {
              const promo = buildRentalPromoSnapshot({
                date_1: rental.date_1,
                time_1: rental.time_1,
                date_2: rental.date_2,
                time_2: rental.time_2,
                from_agency: rental.from_agency,
              });
              return (
                <span>
                  {`${promo.occupancy_days} days · Billable: ${promo.moto_days} days`}
                  <RentalPromoBadges promo={promo} />
                </span>
              );
            }}
          />

          <FunctionField
            label="Rider"
            render={(rental) => {
              return `${rental.booking.r_first_name} ${rental.booking.r_last_name}`;
            }}
          />
          <FunctionField
            label="Nickname"
            render={(rental) => {
              return `${rental.booking.nickname != null ? rental.booking.nickname : ''}`;
            }}
          />
          <FunctionField
            label="Gps Device"
            render={(rental) => {
              if (isEmpty(rental.device)) {
                return "";
              }
              if (!isEmpty(rental.device) && rental.rental_status === 3) {
                return "Gps device deleted";
              }

              return `${rental.device[0] ? rental.device[0].model : "No"} ${rental.device[0]
                ? "(" + rental.device[0].RentalItem.price + " € / day)"
                : ""
                }`;
            }}
          />

          <FunctionField
            label="Tabkbag"
            render={(rental) => {
              return `${rental.tankbag[0] ? rental.device[0].model : "No"} ${rental.tankbag[0]
                ? "(" + rental.tankbag[0].RentalItem.price + " € / day)"
                : ""
                }`;
            }}
          />

          <FunctionField
            label="Jacket"
            render={(rental) => {
              return `${rental.jacket[0] ? rental.jacket[0].model : "No"} ${rental.jacket[0]
                ? "(" + rental.jacket[0].RentalItem.price + " € / day)"
                : ""
                }`;
            }}
          />

          <FunctionField
            label="Gloves"
            render={(rental) => {
              return `${rental.glove[0] ? rental.glove[0].model : "No"} ${rental.glove[0]
                ? "(" + rental.glove[0].RentalItem.price + " € / day)"
                : ""
                }`;
            }}
          />

          <FunctionField
            label="Helmets"
            render={(rental) => {
              return `${rental.helmet[0] ? rental.helmet[0].model : "No"} ${rental.helmet[0]
                ? "(" + rental.helmet[0].RentalItem.price + " € / day)"
                : ""
                }`;
            }}
          />

          <FunctionField
            label="Low Seat"
            render={(rental) => {
              return `${rental.seat[0] ? rental.seat[0].model : "No"}`;
            }}
          />

          <FunctionField
            label="Vip Insurance"
            render={(rental) => {
              return `${rental.insurance[0] && rental.insurance[0].id === 1
                ? "Yes"
                : "No"
                } ${rental.insurance[0] && rental.insurance[0].id === 1
                  ? "(" + rental.insurance[0].RentalItem.price + " € / day)"
                  : ""
                }`;
            }}
          />

          <FunctionField
            label="Vehicle"
            render={(rental) => {
              if (isEmpty(rental.vehicle) && rental.rental_status === 3) {
                return "Deleted (if tour canceled)";
              }
              if (isEmpty(rental.vehicle)) {
                return "No associated vehicle";
              }

              return `${rental.vehicle[0].model.model_name} - ${rental.vehicle[0].licence_plate
                } - (${rental.vehicle[0].RentalItem.price + " € / day)"}`;
            }}
          />

          <FunctionField
            label="Location Fee "
            render={(rental) => {
              return `${rental.locationFee[0]
                ? "Yes (" + rental.locationFee[0].RentalItem.price + " €)"
                : "No"
                }`;
            }}
          />

          <FunctionField
            label="Rewards Used"
            render={(rental) => {
              return `${rental.payments[0] &&
                rental.payments[0].reward &&
                rental.payments[0].reward.points_used > 0
                ? "Yes (" + rental.payments[0].reward.points_used + " points)"
                : "No"
                }`;
            }}
          />

          <NumberField
            source="rental_price"
            label="Total Price"
            options={{ style: "currency", currency: "EUR" }}
          />
          <TextField
            source="imt_comment"
            label="IMT Comments (if charge type not Stripe)"
          />

          {/* <BooleanField label="From Agency" source="from_agency" /> */}

          <TextField source="agency_name" label="Agency Name" />
          <TextField source="agency_contact" label="Agency Contact" />

          {([1, 2, 6, 9].includes(getPermissionRole())) &&
            <TextField source="clientData" label="Card Information" />
          }

          {/*(prop("isAdmin", permissions) || prop("isManager", permissions) || prop("isMaster", permissions)) && (
            <FunctionField
              addLabel={false}
              render={(rental) => {
                return (
                  <CreateChargeButton rental={rental} extraCharge={true} />
                );
              }}
            />
            )*/}
        </Tab>
        {/* {(prop("isAdmin", permissions) || prop("isManager", permissions)) && ( */}
        <Tab label="Payments">
          <ReferenceManyField
            label="Payments"
            reference="payments"
            target="type_id"
            filter={{ type: "rental", refund: 0 }}
          >
            <Datagrid>
              <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} source="date" />
              <NumberField
                source="value"
                options={{ style: "currency", currency: "EUR" }}
              />
              {([1, 2, 3, 6, 9].includes(getPermissionRole())) && (
                  <ShowButton label="Charges" />
                )}
              <TextField source="comments" label="Comments" />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
        {/* )} */}
        {/* {(prop("isAdmin", permissions) || prop("isManager", permissions)) && ( */}
        <Tab label="Extra Payments">
          <ReferenceManyField
            label="Payments"
            reference="payments"
            target="type_id"
            filter={{ type: "extra_charge", refund: 0 }}
          >
            <Datagrid>
              <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} source="date" />
              <NumberField
                source="value"
                options={{ style: "currency", currency: "EUR" }}
              />
              {([1, 2, 3, 6, 9].includes(getPermissionRole())) && (
                  <ShowButton label="Charges" />
                )}
              <TextField source="comments" label="Comments" />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
        {/* )} */}
        {/* <Tab label="Refunds">
            <ReferenceManyField label="Payments" reference="payments" target="type_id" filter={{ type: 'rental', refund: 1 }}>
                <Datagrid>
                    <DateField source="date" />
                    <NumberField source="value" options={{ style: 'currency', currency: 'EUR' }}/>
                    <ShowButton label="Charges"/>
                </Datagrid>
            </ReferenceManyField>
        </Tab> */}
      </TabbedShowLayout>
    </Show>
  );
};



// WEBPACK FOOTER //
// ./src/resources/rentalClients.js